import {
    calculateTotal,
    PivotAgingPartyWise,
    pivotData,
    PivotDataParty,
    PivotDataSummary,
} from "../../Utility/utility"
import { useFetchWithBody } from "../../api/reactQueryCustomHooks"
import { ErrorCard, LoadingCard, NextUITable } from "../../components"
import { apiRoute, ENUM_DASHBOARD_COLOR, GetLoginCredentialDb, outTypeEnum } from "../../constants/enum"
import { useSelector } from "react-redux"
import { CardBody, Card, Chip } from "@heroui/react"
import { useCallback, useEffect, useMemo, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons"
import {
    COLUMN_ALIGN_TYPE,
    COLUMN_TYPE,
    FOOTER_TYPE,
    SELECTION_MODE,
} from "../../components/NextUITable"
export const DashboardCombineOutstanding = () => {

    const { user } = useSelector((state) => state.auth)
    const { compCode, yearId } = useSelector((state) => state.company)

    const {
        isLoading,
        isError,
        data = [],
    } = useFetchWithBody({
        url: apiRoute.dashboard.getOutstandingData,
        queryKey: "DashboardOutCombine",
        inputData: {
            compcode: compCode.join(","),
            action: "Combine Summary",
            out_type: outTypeEnum.C,
            party_id: "0",
           // db_user: GetLoginCredentialDb(user, yearId)
        },
    })


    const totalPayAmount = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Payable_Amount",
            }),
        [data]
    )
    const totalRecAmount = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Receivable_Amount",
            }),
        [data]
    )
    const totalDiffAmount = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Diff_Amount",
            }),
        [data]
    )
    const INITIAL_VISIBLE_COLUMNS = ["Month_Year", "Receivable_Amount", "Payable_Amount", "Diff_Amount"]
    const topActionFilter = []

    const columns = [
        {
            name: "Month",
            uid: "Month_Year",
            sortable: true,
            textcolor: ENUM_DASHBOARD_COLOR.Comb_MonthYear,
        },
        {

            name: "Receivable",
            uid: "Receivable_Amount",
            textcolor: ENUM_DASHBOARD_COLOR.Comb_Receivable,
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalRecAmount,
            }
        },
        {
            name: "Payable",
            uid: "Payable_Amount",
            textcolor: ENUM_DASHBOARD_COLOR.Comb_Payable,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalPayAmount,
            }
        },
        {
            name: "Difference",
            uid: "Diff_Amount",
            align: COLUMN_ALIGN_TYPE.center,
            textcolor: ENUM_DASHBOARD_COLOR.Comb_Difference,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalDiffAmount,
            }
        }
    ]

    if (isError) <ErrorCard />
    if (isLoading) <LoadingCard />

    return (
        <div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                {/* table */}
                <Card>
                    <CardBody>
                        <NextUITable
                            INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                            data={data}
                            columns={columns}
                            showTopContent={false}
                            showPagination={false}
                            topActionFilter={topActionFilter}
                            id="combine"
                        />
                    </CardBody>
                </Card>

            </div>
        </div>
    )
}
